module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// ../common/temp/~/.pnpm/webpack@1.15.0/~/webpack/buildin/amd-options.js
// module id = 109
// module chunks = 0